/* ==========================================================================
   Lumi Homepage — JavaScript
   Tabs, accordions, carousel scroll, and dot navigation
   ========================================================================== */

(function () {
  'use strict';

  /* --------------------------------------------------------------------------
     Tabs
     -------------------------------------------------------------------------- */

  function initTabs() {
    document.querySelectorAll('[data-microdose-tabs]').forEach(function (tabGroup) {
      var tabs = tabGroup.querySelectorAll('[data-microdose-tab]');
      var panels = tabGroup.querySelectorAll('[data-microdose-panel]');
      var tabBar = tabGroup.querySelector('.microdose-tabs');

      // Create sliding pill indicator
      var slider = tabBar ? tabBar.querySelector('.microdose-tabs__slider') : null;
      if (tabBar && !slider) {
        slider = document.createElement('div');
        slider.className = 'microdose-tabs__slider';
        tabBar.prepend(slider);
      }

      function moveSlider(activeTab) {
        if (!slider || !tabBar) return;
        var tabBarRect = tabBar.getBoundingClientRect();
        var tabRect = activeTab.getBoundingClientRect();
        var offsetLeft = tabRect.left - tabBarRect.left - 3;
        slider.style.width = tabRect.width + 'px';
        slider.style.transform = 'translateX(' + offsetLeft + 'px)';
      }

      // Position slider on initial active tab
      var activeTab = tabBar ? tabBar.querySelector('.microdose-tab.is-active') : null;
      if (activeTab) {
        moveSlider(activeTab);
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.getAttribute('data-microdose-tab');

          tabs.forEach(function (t) { t.classList.remove('is-active'); });
          panels.forEach(function (p) { p.classList.remove('is-active'); });

          tab.classList.add('is-active');
          moveSlider(tab);

          var panel = tabGroup.querySelector('[data-microdose-panel="' + target + '"]');
          if (panel) panel.classList.add('is-active');

          var heroSection = tabGroup.closest('.microdose-hero');
          if (heroSection) {
            var allBags = heroSection.querySelectorAll('[data-pack-images]');
            allBags.forEach(function (b) { b.classList.remove('is-active'); });
            var activeBags = heroSection.querySelector('[data-pack-images="' + target + '"]');
            if (activeBags) activeBags.classList.add('is-active');

            var allAtcPanels = heroSection.querySelectorAll('[data-microdose-pack-atc-panel]');
            allAtcPanels.forEach(function (f) { f.classList.remove('is-active'); });
            var activeAtc = heroSection.querySelector('[data-microdose-pack-atc-panel="' + target + '"]');
            if (activeAtc) activeAtc.classList.add('is-active');

            var gradientStart = tab.getAttribute('data-pack-gradient-start');
            var gradientEnd = tab.getAttribute('data-pack-gradient-end');
            var container = heroSection.querySelector('[data-hero-images-container]');
            if (container && gradientStart && gradientEnd) {
              container.style.setProperty('--pack-gradient-start', gradientStart);
              container.style.setProperty('--pack-gradient-end', gradientEnd);
            }
          }
        });
      });

      // Reposition on resize
      window.addEventListener('resize', function () {
        var current = tabBar ? tabBar.querySelector('.microdose-tab.is-active') : null;
        if (current) moveSlider(current);
      });
    });
  }

  /* --------------------------------------------------------------------------
     Accordions
     -------------------------------------------------------------------------- */

  function initAccordions() {
    document.querySelectorAll('.microdose-accordion__trigger, .microdose-faq__question').forEach(function (trigger) {
      if (trigger._microdoseAccordionInit) return;
      trigger._microdoseAccordionInit = true;
      trigger.addEventListener('click', function () {
        var item = trigger.closest('.microdose-accordion__item');
        if (!item) return;

        var isOpen = item.classList.contains('is-open');
        var content = item.querySelector('.microdose-accordion__content');
        if (!content) return;

        if (isOpen) {
          content.style.maxHeight = content.scrollHeight + 'px';
          void content.offsetHeight;
          content.style.maxHeight = '0';
          item.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('is-open');
          content.style.maxHeight = content.scrollHeight + 'px';
          trigger.setAttribute('aria-expanded', 'true');
          content.addEventListener('transitionend', function handler() {
            if (item.classList.contains('is-open')) {
              content.style.maxHeight = 'none';
            }
            content.removeEventListener('transitionend', handler);
          });
        }
      });
    });
  }

  /* --------------------------------------------------------------------------
     Scroll carousels with dot indicators
     -------------------------------------------------------------------------- */

  function initCarousels() {
    document.querySelectorAll('[data-microdose-carousel]').forEach(function (carousel) {
      var scrollContainer = carousel.querySelector('.microdose-scroll');
      var dotsContainer = carousel.querySelector('.microdose-dots');
      if (!scrollContainer) return;

      var items = scrollContainer.children;
      if (!items.length) return;

      // Build dots
      if (dotsContainer) {
        dotsContainer.innerHTML = '';
        for (var i = 0; i < items.length; i++) {
          var dot = document.createElement('button');
          dot.className = 'microdose-dot' + (i === 0 ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          dot.setAttribute('data-index', i);
          dot.addEventListener('click', function () {
            var index = parseInt(this.getAttribute('data-index'));
            var itemLeft = items[index].offsetLeft - scrollContainer.offsetLeft;
            scrollContainer.scrollTo({ left: itemLeft, behavior: 'smooth' });
          });
          dotsContainer.appendChild(dot);
        }
      }

      // Update dots on scroll
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && dotsContainer) {
            var index = Array.prototype.indexOf.call(items, entry.target);
            dotsContainer.querySelectorAll('.microdose-dot').forEach(function (d, di) {
              d.classList.toggle('is-active', di === index);
            });
          }
        });
      }, {
        root: scrollContainer,
        threshold: 0.6
      });

      Array.prototype.forEach.call(items, function (item) {
        observer.observe(item);
      });

      // Auto-scroll — uses scrollLeft instead of scrollIntoView to avoid page jump
      var autoSpeed = carousel.getAttribute('data-microdose-autoscroll');
      if (autoSpeed) {
        var speed = parseFloat(autoSpeed) * 1000;
        var currentIndex = 0;

        function autoScroll() {
          currentIndex = (currentIndex + 1) % items.length;
          var itemLeft = items[currentIndex].offsetLeft - scrollContainer.offsetLeft;
          scrollContainer.scrollTo({ left: itemLeft, behavior: 'smooth' });
        }

        var interval = setInterval(autoScroll, speed);

        scrollContainer.addEventListener('pointerdown', function () {
          clearInterval(interval);
        });

        scrollContainer.addEventListener('pointerup', function () {
          interval = setInterval(autoScroll, speed);
        });
      }
    });
  }

  /* --------------------------------------------------------------------------
     Initialize on DOM ready
     -------------------------------------------------------------------------- */

  function init() {
    initTabs();
    initAccordions();
    initCarousels();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init for Shopify Theme Editor
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }
})();
